import { render, staticRenderFns } from "./CommonPamarly.vue?vue&type=template&id=ce150888&"
import script from "./CommonPamarly.vue?vue&type=script&lang=js&"
export * from "./CommonPamarly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports